<template>
  <div>
    <PCNavbar selectIndex="1-1" style="background: #ececec;"/>
    <MobileNavBar :currentActive="1" />
    <Club/>
    <MobileList/>
    <!--  页脚  -->
    <Footer/>

  </div>
</template>

<script>
import PCNavbar from '@/views/home/navbar/indexDetail.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import Footer from '@/views/home/callme/footerIndex.vue'
import Club from "@/views/business/club/list.vue";
import MobileList from "@/views/business/club/mobileList.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Club,
    MobileList,
    Footer
  },
}
</script>

<style>
</style>